import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { MARKETPLACE_PAGE_SIZE } from '#pplx/frontend/apps/ask/computer-plugins/marketplaceConstants.js';
import { getSourcesQueryKeyPrefix } from '#pplx/frontend/apps/ask/queries/query-keys/sourcesKeys.js';
import { useInfiniteQuery } from '#pplx/frontend/react-query/useInfiniteQuery.js';
import { sourceserviceClient } from '#pplx_generated/typespec/rest/sourceservice/client.js';
export const useConnectedConnectors = (enabled = true) => useInfiniteQuery({
    queryKey: [...getSourcesQueryKeyPrefix(), 'installed'],
    enabled,
    initialPageParam: undefined,
    queryFn: async ({ pageParam }) => {
        const { data, error, response } = await sourceserviceClient.GET('/rest/sources', 'installed-connectors-section', {
            params: {
                query: {
                    limit: MARKETPLACE_PAGE_SIZE,
                    cursor: pageParam,
                    filter_by: 'connected',
                    use_catalog: true,
                    product_surface: 'computer',
                },
            },
        });
        if (error || !data) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to fetch installed connectors',
                status: response.status,
            });
        }
        return data;
    },
    getNextPageParam: (page) => page.next_cursor ?? undefined,
});
//# sourceMappingURL=useConnectedConnectors.js.map